"use strict";
var NativePromiseConstructor = require("../internals/promise-native-constructor");
var checkCorrectnessOfIteration = require("../internals/check-correctness-of-iteration");
var FORCED_PROMISE_CONSTRUCTOR = require("../internals/promise-constructor-detection").CONSTRUCTOR;
module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function(iterable) {
  NativePromiseConstructor.all(iterable).then(void 0, function() {
  });
});
